import Box from "@mui/material/Box";

const Page = (props) => {
  return <Box sx={{ m: 2 }}>LOCALES</Box>;
};

export default Page;
